import holidays from '../data/holidays.json';
import zmanim from '../data/zmanim.json';

export function loadZmanimRows() {
  return zmanim;
}

export function loadHolidaysRows() {
  return holidays;
}
